import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { NgSignaturePad } from '../../../../ng-signaturepad/models/ng-signaturepad.interfaces';
import { AssessmentDto } from '../assessment-details/assessment.dto';
import { AssessmentService } from '../assessment.service';

@Component({
  selector: 'app-assessment-signature',
  templateUrl: './assessment-signature.component.html',
})
export class AssessmentSignatureComponent implements OnInit {
  private readonly destroy$: Subject<void> = new Subject();
  @ViewChild('signaturePad', { static: false }) signaturePad: NgSignaturePad;
  public width: number = 400;
  public height: number = 200;
  private type: 'image/jpeg' | 'image/svg+xml';
  public assessment: AssessmentDto;
  public assessmentSignatureForm: FormGroup<{
    byPhone: FormControl<string | null>;
  }>;
  public displaySignaturePad: boolean = true;

  private confirmCallback: (data?: string) => void;

  constructor(
    private modal: NgbActiveModal,
    private readonly assessmentService: AssessmentService,
  ) {}

  ngOnInit(): void {
    this.assessmentSignatureForm = new FormGroup({
      byPhone: new FormControl<string | null>('false', [Validators.required]),
    });

    this.assessmentSignatureForm.controls.byPhone.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((byPhone: string) => {
      this.displaySignaturePad = byPhone !== 'true';
    });
  }

  public get isEmpty(): boolean {
    if (!this.displaySignaturePad) {
      return true;
    }
    return this.signaturePad ? this.signaturePad.isEmpty() : true;
  }

  public async confirm(type?: 'image/jpeg' | 'image/svg+xml'): Promise<string> {
    this.type = type;
    return new Promise<string>((resolve: (value: string) => void) => {
      this.confirmCallback = async (data?: string) => {
        this.modal.close();
        resolve(data);
      };
    });
  }

  public accept(): void {
    if ((this.displaySignaturePad && !this.signaturePad.isEmpty()) || !this.displaySignaturePad) {
      this.confirmCallback(this.signaturePad?.toDataURL(this.type));
    }
  }

  public cancel(): void {
    this.modal.close();
  }

  public clear: () => void = () => this.signaturePad.clear();
}
